import {
  FETCH_BOOK_PERFORMANCE_PUBLISHERS,
  FETCH_BOOK_PERFORMANCE_PUBLISHERS_SUCCESS,
  FETCH_BOOK_PERFORMANCE_PUBLISHERS_FAILURE,
  FETCH_BOOK_PERFORMANCE,
  FETCH_BOOK_PERFORMANCE_SUCCESS,
  FETCH_BOOK_PERFORMANCE_FAILURE,
  FETCH_BOOK_PERFORMANCE_TREND,
  FETCH_BOOK_PERFORMANCE_TREND_SUCCESS,
  FETCH_BOOK_PERFORMANCE_TREND_FAILURE,
  FETCH_BOOK_PERFORMANCE_DETAIL,
  FETCH_BOOK_PERFORMANCE_DETAIL_SUCCESS,
  FETCH_BOOK_PERFORMANCE_DETAIL_FAILURE,
  CLEAR_BOOK_PERFORMANCE_DETAIL,
  EXPORT_BOOK_PERFORMANCE_CSV,
  EXPORT_BOOK_PERFORMANCE_CSV_SUCCESS,
  EXPORT_BOOK_PERFORMANCE_CSV_FAILURE,
  FETCH_BOOK_PERFORMANCE_AUTHORS,
  FETCH_BOOK_PERFORMANCE_AUTHORS_SUCCESS,
  FETCH_BOOK_PERFORMANCE_AUTHORS_FAILURE,
  FETCH_AUTHOR_BOOK_PERFORMANCE,
  FETCH_AUTHOR_BOOK_PERFORMANCE_SUCCESS,
  FETCH_AUTHOR_BOOK_PERFORMANCE_FAILURE,
  FETCH_AUTHOR_BOOK_PERFORMANCE_TREND,
  FETCH_AUTHOR_BOOK_PERFORMANCE_TREND_SUCCESS,
  FETCH_AUTHOR_BOOK_PERFORMANCE_TREND_FAILURE,
} from "../ActionTypes";

const request =
  (type) =>
  (payload = {}) => ({ type, payload });
const result = (type) => (payload) => ({ type, payload });

export const fetchBookPerformancePublishers = request(FETCH_BOOK_PERFORMANCE_PUBLISHERS);
export const fetchBookPerformancePublishersSuccess = result(
  FETCH_BOOK_PERFORMANCE_PUBLISHERS_SUCCESS
);
export const fetchBookPerformancePublishersFailure = result(
  FETCH_BOOK_PERFORMANCE_PUBLISHERS_FAILURE
);
export const fetchBookPerformance = request(FETCH_BOOK_PERFORMANCE);
export const fetchBookPerformanceSuccess = result(FETCH_BOOK_PERFORMANCE_SUCCESS);
export const fetchBookPerformanceFailure = result(FETCH_BOOK_PERFORMANCE_FAILURE);
export const fetchBookPerformanceTrend = request(FETCH_BOOK_PERFORMANCE_TREND);
export const fetchBookPerformanceTrendSuccess = result(FETCH_BOOK_PERFORMANCE_TREND_SUCCESS);
export const fetchBookPerformanceTrendFailure = result(FETCH_BOOK_PERFORMANCE_TREND_FAILURE);
export const fetchBookPerformanceDetail = request(FETCH_BOOK_PERFORMANCE_DETAIL);
export const fetchBookPerformanceDetailSuccess = result(FETCH_BOOK_PERFORMANCE_DETAIL_SUCCESS);
export const fetchBookPerformanceDetailFailure = result(FETCH_BOOK_PERFORMANCE_DETAIL_FAILURE);
export const clearBookPerformanceDetail = request(CLEAR_BOOK_PERFORMANCE_DETAIL);
export const exportBookPerformanceCsv = request(EXPORT_BOOK_PERFORMANCE_CSV);
export const exportBookPerformanceCsvSuccess = result(EXPORT_BOOK_PERFORMANCE_CSV_SUCCESS);
export const exportBookPerformanceCsvFailure = result(EXPORT_BOOK_PERFORMANCE_CSV_FAILURE);
export const fetchBookPerformanceAuthors = request(FETCH_BOOK_PERFORMANCE_AUTHORS);
export const fetchBookPerformanceAuthorsSuccess = result(FETCH_BOOK_PERFORMANCE_AUTHORS_SUCCESS);
export const fetchBookPerformanceAuthorsFailure = result(FETCH_BOOK_PERFORMANCE_AUTHORS_FAILURE);
export const fetchAuthorBookPerformance = request(FETCH_AUTHOR_BOOK_PERFORMANCE);
export const fetchAuthorBookPerformanceSuccess = result(FETCH_AUTHOR_BOOK_PERFORMANCE_SUCCESS);
export const fetchAuthorBookPerformanceFailure = result(FETCH_AUTHOR_BOOK_PERFORMANCE_FAILURE);
export const fetchAuthorBookPerformanceTrend = request(FETCH_AUTHOR_BOOK_PERFORMANCE_TREND);
export const fetchAuthorBookPerformanceTrendSuccess = result(
  FETCH_AUTHOR_BOOK_PERFORMANCE_TREND_SUCCESS
);
export const fetchAuthorBookPerformanceTrendFailure = result(
  FETCH_AUTHOR_BOOK_PERFORMANCE_TREND_FAILURE
);
